(function () {
  'use strict';

  if (window.__lpEditorialHeroVariantBound) return;
  window.__lpEditorialHeroVariantBound = true;

  function formatMoney(cents) {
    if (
      typeof theme !== 'undefined' &&
      theme.utils &&
      typeof theme.utils.formatMoney === 'function'
    ) {
      return theme.utils.formatMoney(cents);
    }
    var amount = (Number(cents) || 0) / 100;
    return '$' + amount.toFixed(2);
  }

  function cartPermalink(variantId, quantity, discountCode) {
    var qty = quantity || 1;
    var base =
      typeof theme !== 'undefined' && theme.urls && theme.urls.cart
        ? theme.urls.cart
        : '/cart';
    var url = base.replace(/\/$/, '') + '/' + variantId + ':' + qty;
    if (discountCode) {
      url += '?discount=' + encodeURIComponent(discountCode);
    }
    return url;
  }

  function closePicker(root) {
    var picker = root.querySelector('[data-lp-hero-variant]') || root;
    var list = root.querySelector('[data-lp-hero-variant-list]');
    if (!picker || !list) return;
    list.hidden = true;
    picker.setAttribute('aria-expanded', 'false');
    picker.classList.remove('active', 'visible', 'is-open');
  }

  function openPicker(root) {
    var picker = root.querySelector('[data-lp-hero-variant]') || root;
    var list = root.querySelector('[data-lp-hero-variant-list]');
    if (!picker || !list) return;
    list.hidden = false;
    picker.setAttribute('aria-expanded', 'true');
    picker.classList.add('active', 'visible', 'is-open');
  }

  function togglePicker(root) {
    var list = root.querySelector('[data-lp-hero-variant-list]');
    if (!list) return;
    if (list.hidden) openPicker(root);
    else closePicker(root);
  }

  function updatePrice(root, option) {
    var current = root.querySelector('[data-lp-hero-current]');
    var compare = root.querySelector('[data-lp-hero-compare]');
    var triggerCurrent = root.querySelector('[data-lp-hero-trigger-current]');
    var triggerCompare = root.querySelector('[data-lp-hero-trigger-compare]');
    var price = parseInt(option.getAttribute('data-price'), 10) || 0;
    var compareAt = parseInt(option.getAttribute('data-compare-at-price'), 10) || 0;
    var money = formatMoney(price);
    var compareMoney = compareAt > price ? formatMoney(compareAt) : '';

    if (current) current.textContent = money;
    if (triggerCurrent) triggerCurrent.textContent = money;

    if (compare) {
      if (compareMoney) {
        compare.textContent = compareMoney;
        compare.hidden = false;
        compare.removeAttribute('hidden');
      } else {
        compare.textContent = '';
        compare.hidden = true;
        compare.setAttribute('hidden', '');
      }
    }

    if (triggerCompare) {
      if (compareMoney) {
        triggerCompare.textContent = compareMoney;
        triggerCompare.hidden = false;
        triggerCompare.removeAttribute('hidden');
      } else {
        triggerCompare.textContent = '';
        triggerCompare.hidden = true;
        triggerCompare.setAttribute('hidden', '');
      }
    }
  }

  function updateTrigger(root, option) {
    var nameEl = root.querySelector('[data-lp-hero-variant-name]');
    var badgeEl = root.querySelector('[data-lp-hero-variant-badge]');
    var title = option.getAttribute('data-variant-title') || '';
    var badge = option.getAttribute('data-badge') || '';

    if (nameEl) nameEl.textContent = title;

    if (badgeEl) {
      if (badge) {
        badgeEl.textContent = badge;
        badgeEl.hidden = false;
        badgeEl.removeAttribute('hidden');
      } else {
        badgeEl.textContent = '';
        badgeEl.hidden = true;
        badgeEl.setAttribute('hidden', '');
      }
    }
  }

  function selectOption(root, option) {
    if (!option || option.getAttribute('aria-disabled') === 'true') return;
    if (option.classList.contains('disabled')) return;

    var variantId = option.getAttribute('data-variant-id');
    var available = option.getAttribute('data-available') !== 'false';
    var qty = parseInt(root.getAttribute('data-quantity'), 10) || 1;
    var atc = root.querySelector('[data-lp-hero-atc]');
    var options = root.querySelectorAll('[data-lp-hero-variant-option]');

    options.forEach(function (el) {
      var selected = el === option;
      el.classList.toggle('is-selected', selected);
      el.classList.toggle('active', selected);
      el.classList.toggle('selected', selected);
      el.setAttribute('aria-selected', selected ? 'true' : 'false');
    });

    updateTrigger(root, option);
    updatePrice(root, option);

    if (atc) {
      var discountCode = root.getAttribute('data-discount-code') || '';
      atc.href = cartPermalink(variantId, qty, discountCode);
      atc.setAttribute('data-variant-id', variantId);
      if (available) {
        atc.removeAttribute('aria-disabled');
        atc.removeAttribute('tabindex');
      } else {
        atc.setAttribute('aria-disabled', 'true');
        atc.setAttribute('tabindex', '-1');
      }
    }

    closePicker(root);
  }

  function onDocumentClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var disabledAtc = target.closest('[data-lp-hero-atc][aria-disabled="true"]');
    if (disabledAtc) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    var root = target.closest('[data-lp-hero-product-cta]');
    if (!root) {
      document.querySelectorAll('[data-lp-hero-variant].is-open').forEach(function (picker) {
        closePicker(picker.closest('[data-lp-hero-product-cta]') || picker);
      });
      return;
    }

    var option = target.closest('[data-lp-hero-variant-option]');
    if (option && root.contains(option)) {
      event.preventDefault();
      selectOption(root, option);
      return;
    }

    var trigger = target.closest('[data-lp-hero-variant-trigger]');
    if (trigger && root.contains(trigger)) {
      event.preventDefault();
      togglePicker(root);
      return;
    }

    if (!target.closest('[data-lp-hero-variant]')) {
      closePicker(root);
    }
  }

  function onKeydown(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var root = target.closest('[data-lp-hero-product-cta]');
    if (!root) {
      if (event.key === 'Escape') {
        document.querySelectorAll('[data-lp-hero-variant].is-open').forEach(function (picker) {
          closePicker(picker.closest('[data-lp-hero-product-cta]') || picker);
        });
      }
      return;
    }

    var picker = root.querySelector('[data-lp-hero-variant]');
    if (!picker) return;

    if (event.key === 'Escape') {
      closePicker(root);
      picker.focus();
      return;
    }

    if (
      (event.key === 'Enter' || event.key === ' ') &&
      target.closest('[data-lp-hero-variant-trigger]')
    ) {
      event.preventDefault();
      togglePicker(root);
    }
  }

  document.addEventListener('click', onDocumentClick);
  document.addEventListener('keydown', onKeydown);
})();
